<template>
  <div>
    <div class="content-area__heading mb-2 flex items-center">
      <div class="flex flex-col justify-center items-center">
        <vs-image
          v-if="player.profile_photo"
          class="w-32 mr-3 bg-no-repeat"
          :src="
            player.profile_photo &&
              `https://res.cloudinary.com/ballstar/image/upload/c_thumb,w_150/${player.profile_photo.path}`
          "
        />
        <span v-if="player.isnba"
          ><img
            v-if="player.profile_photo"
            class="w-16 pt-1 bg-no-repeat"
            :src="
              player.profile_photo &&
                `https://res.cloudinary.com/ballstar/image/upload/v169050202735/nba-wide-logo.jpg`
            "
        /></span>
      </div>
      <div class="mx-3">
        <div class="flex items-center">
          <div class="flex-auto">
            <h2 class="mb-2">{{ player.firstname }} {{ player.lastname }}</h2>
          </div>
          <div class="flex-auto">
            <span v-if="false"
              ><vs-avatar color="primary" icon="star_border"
            /></span>
          </div>
        </div>
        <h4 class="mb-2">
          {{ player.height ? `Height: ${player.height}` : "" }}
          {{ player.weight ? `Weight: ${player.weight}` : "" }}
        </h4>
        <h4 class="mb-2">
          {{ player.position ? `Position: ${player.position}` : "" }}
        </h4>
        <h4 class="mb-2">
          {{ player.hometown ? `Hometown: ${player.hometown}` : "" }}
        </h4>
        <div class="social-icons">
          <ul>
            <a
              v-if="player.instagram"
              target="_blank"
              :href="`https://instagram.com/${player.instagram}`"
              ><img
                class="mr-3"
                style="height: 20px; width: 20px; margin: 0 3 0 0"
                src="https://res.cloudinary.com/ballstar/image/upload/v1689737600/Instagram_Glyph_Gradient_vmrvl2.png"
            /></a>
            <a
              v-if="player.twitter"
              target="_blank"
              :href="`https://twitter.com/${player.twitter}`"
              ><img
                class="mr-3"
                style="height: 20px; width: 20px; margin: 0 3 0 0"
                src="https://res.cloudinary.com/ballstar/image/upload/v1689785921/2021_Twitter_logo_-_blue_bl3cfr.png"
            /></a>
            <a
              v-if="player.tiktok"
              target="_blank"
              :href="`https://tiktok.com/${player.tiktok}`"
              ><img
                class="mr-3"
                style="height: 20px; width: 20px; margin: 0 3 0 0"
                src="https://res.cloudinary.com/ballstar/image/upload/v1689786682/TikTok_Icon_Black_Circle_idbu4r.png"
            /></a>
          </ul>
        </div>
      </div>
    </div>
    <vx-card>
      <vs-tabs>
        <vs-tab label="Results">
          <div class="tab-text">
            <vs-table :data="games" :noDataText="emptyGameTxt">
              <template slot="thead">
                <vs-th>Date</vs-th>
                <vs-th>League</vs-th>
                <vs-th>Opponent</vs-th>
                <vs-th>Score</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr v-for="tr in data" :key="tr.id">
                  <vs-td
                    :data="tr.game_date && dateFormat(Date.parse(tr.game_date))"
                  >
                    {{ tr.game_date && dateFormat(Date.parse(tr.game_date)) }}
                  </vs-td>
                  <vs-td :data="tr.league_name">
                    <router-link
                      :to="{
                        name: 'league',
                        params: { id: tr.league_id }
                      }"
                    >
                      {{ tr.league_name }}
                    </router-link>
                  </vs-td>

                  <vs-td
                    :data="
                      player.team_id === tr.hometeam_id
                        ? tr.awayteam_name
                        : tr.hometeam_name
                    "
                  >
                    <router-link
                      :to="{
                        name: 'team',
                        params: {
                          id:
                            player.team_id === tr.hometeam_id
                              ? tr.awayteam_id
                              : tr.hometeam_id
                        }
                      }"
                    >
                      {{
                        player.team_id === tr.hometeam_id
                          ? tr.awayteam_name
                          : tr.hometeam_name
                      }}
                    </router-link>
                  </vs-td>
                  <vs-td :data="score(tr)">
                    <router-link
                      :to="{ name: 'boxscore', params: { id: tr.game_id } }"
                    >
                      {{ score(tr) }}
                    </router-link>
                  </vs-td>

                  <template class="expand-player" slot="expand">
                    <div class="con-expand-users">
                      <div class="con-btns-user">
                        <div class="con-userx">
                          <BoxscoreListing :id="tr.game_id" />
                        </div>
                      </div>
                    </div>
                  </template>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vs-tab>
      </vs-tabs>
    </vx-card>
  </div>
</template>
<script>
import playerApi from "@/api/player";
import BoxscoreListing from "@/views/pages/leagues/BoxscoreListing";
const dateTimeFormat = new Intl.DateTimeFormat("en", {
  year: "numeric",
  month: "short",
  day: "2-digit"
});

export default {
  name: "Player",
  created() {
    this.loadPlayerGames();
  },
  props: ["id"],
  components: { BoxscoreListing },
  watch: {
    id() {
      this.loadPlayerGames();
    }
  },
  data() {
    return {
      games: [],
      player: {},
      emptyGameTxt: ""
    };
  },
  computed: {
    playerName() {
      return this.player && this.player.name;
    }
  },
  methods: {
    dateFormat(d) {
      return dateTimeFormat.format(d);
    },
    async loadPlayerGames() {
      this.emptyGameTxt = "Searching Ballstar database...";
      const { json } = await playerApi.get(this.id);
      if (json.games && !json.games.length) {
        this.emptyGameTxt = "No Games found";
      }

      this.games = json.games.sort(
        (b, a) => new Date(a.game_date) - new Date(b.game_date)
      );
      this.player = json.player;
    },
    myTeam(game, meta) {
      if (meta.team.id === game.away_team.id) {
        return game.away_team;
      }

      return game.home_team;
    },
    opponent(game, meta) {
      if (meta.team.id === game.away_team.id) {
        return game.home_team;
      }

      return game.away_team;
    },
    opponentId(gameData) {
      if (gameData.away_team.id === this.id) {
        return gameData.home_team.id;
      } else if (gameData.home_team.id === this.id) {
        return gameData.away_team.id;
      }

      return null;
    },
    winLoss(gameData) {
      if (gameData.away_team.id === this.id) {
        if (gameData.away_team_score > gameData.home_team_score) {
          return "WIN";
        } else if (gameData.away_team_score < gameData.home_team_score) {
          return "LOSS";
        }

        return "TIE";
      } else if (gameData.home_team.id === this.id) {
        if (gameData.home_team_score > gameData.away_team_score) {
          return "WIN";
        } else if (gameData.home_team_score < gameData.away_team_score) {
          return "LOSS";
        }

        return "TIE";
      }

      return "";
    },
    score(gameData) {
      return `${gameData.away_team_score} - ${gameData.home_team_score}`;
    }
  },
  metaInfo() {
    return { title: this.$route.meta.title };
  }
};
</script>
